module.exports = __webpack_public_path__ + "static/fonts/PingFang-Medium.45cac8d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/bootstrap/fonts/PingFang-Medium.ttf
// module id = VNhC
// module chunks = 1